import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { FrameSwitcher, Frame } from 'components';
import IncludeBanner, { IncludeBannerProps } from 'bricks/IncludeBanner';
import IncludeBannerContent from 'bricks/IncludeBannerContent';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const frameSwitcherProps = {
  adjustmentDisplaceRatio: 0.3,
  autoSwitchTime: 10000,
  draggable: true,
  arrowClass: 'arrowExternal',
  framesPerSlide: 1,
  step: 1,
  gutter: 0,
  drag: true,
  opacityLayer: false,
};

export default class BannerContainer extends Component {
  componentDidMount() {
    const { onMount, isMobile } = this.props;
    if (onMount) {
      onMount(isMobile);
    }
  }

  renderFrameList = () => {
    const { list, isMobile, onBannerClick, outFrame, outFramePosition } = this.props;

    const mappedList = list.map((banner, index) => (
      <Frame key={+index}>
        {banner.markup ?
          <IncludeBannerContent
            className={cx('content', isMobile && 'mobile')}
            htmlContent={banner.markup}
            onClick={() => onBannerClick(banner, index, isMobile)}
            {...{ isMobile }}
          />
        : <IncludeBanner
            className={cx('content', isMobile && 'mobile')}
            {...banner}
            onClick={() => onBannerClick(banner, index, isMobile)}
            {...{ isMobile }}
          />
        }
      </Frame>
    ));

    if (outFrame) {
      const frame = <Frame key={-1}>{outFrame}</Frame>;
      const position = outFramePosition || 0;

      mappedList.splice(position, 0, frame);
    }

    return mappedList;
  };

  render() {
    const { list, isMobile, className, onSwitch } = this.props;

    return (
      list &&
      list.length !== 0 && (
        <div className={className}>
          <FrameSwitcher
            {...frameSwitcherProps}
            adjustmentTimeout={(list || []).length > 1 ? 150 : null}
            cycle={(list || []).length > 1}
            draggable={(list || []).length > 1}
            noArrows={isMobile || list.length <= 1}
            noSwitch={list.length <= 1}
            arrowClass={[frameSwitcherProps.arrowClass, cx('overriddenArrow')]}
            onSwitchStart={(eq) => {
              onSwitch(eq, isMobile);
            }}
          >
            {this.renderFrameList()}
          </FrameSwitcher>
        </div>
      )
    );
  }
}

BannerContainer.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape(IncludeBannerProps)),
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  onMount: PropTypes.func,
  onSwitch: PropTypes.func,
  onBannerClick: PropTypes.func,
  outFrame: PropTypes.any,
  outFramePosition: PropTypes.number,
  bannerClass: PropTypes.string,
};
